export default "__VITE_ASSET__3e334966__"